import { Box, Skeleton, Typography, useTheme } from "@mui/material";
import CButton from "components/CButton";
import CDialog from "components/CDialog";
import { FC } from "react";
import { ClosingCostDetails } from "screens/FinalOffer/useHelocOffer";
import Loan from "typedef/Loan";
import { PrivateLabelFees } from "typedef/PrivateLabelFees";
import dollarFormatter from "utils/FormatterDollar";
import toPercentage from "utils/toPercentage";
interface Props {
  openModal: boolean;
  onClose: () => void;
  loan?: Loan;
  loanAmount: number;
  fees?: PrivateLabelFees & ClosingCostDetails;
  originationFee: number | null | undefined;
  originalTotalFee: number;
}

const LEGAL_VESTING_FEES = 65;

const FeesModal: FC<Props> = ({
  openModal,
  onClose,
  loan,
  fees,
  originationFee,
  originalTotalFee,
}) => {
  const totalFormated = dollarFormatter.format(
    Number(originationFee ? fees?.totalFees : 0),
  );
  const theme = useTheme();
  const offerAmount = loan?.finalOffer?.amount ?? loan?.initialOffer?.amount;
  const isWA = loan?.property?.address?.components?.state_abbreviation === "WA";
  return (
    <CDialog open={openModal} onClose={onClose} maxWidth="md" fullWidth>
      <Box display="flex" flexDirection="column">
        <Typography fontSize="25px" fontWeight={600} textAlign={"left"}>
          Estimated Fees
        </Typography>
        <Typography
          fontSize="22px"
          fontWeight={600}
          textAlign={"left"}
          marginTop="25px"
          data-cy="originationFee"
        >
          {loan?.property.address.components.state_abbreviation !== "MI"
            ? "Origination Fee"
            : "Processing Fee"}{" "}
          {`(${toPercentage(originalTotalFee)})`}:{" "}
          {dollarFormatter.format(Number(originationFee ?? 0))}
        </Typography>
        <Box
          display="flex"
          flexDirection="column"
          marginTop="20px"
          marginBottom="20px"
        >
          <Typography fontSize="20px" fontWeight={600} textAlign="left">
            Fees:
          </Typography>
          <Typography fontSize="20px" textAlign={"left"}>
            Credit Report: {dollarFormatter.format(fees?.creditReport ?? 0)}
          </Typography>
          <Typography fontSize="20px" textAlign={"left"}>
            Compliance / Doc Prep / Enote:{" "}
            {dollarFormatter.format(fees?.complianceDocPrepeNote ?? 0)}
          </Typography>
          <Typography fontSize="20px" textAlign={"left"}>
            Property AVM / Inspection:{" "}
            {dollarFormatter.format(fees?.AVMInspection ?? 0)}
          </Typography>
          <Typography fontSize="20px" textAlign={"left"}>
            ID Verification: {dollarFormatter.format(fees?.IDVerification ?? 0)}
          </Typography>
          <Typography fontSize="20px" textAlign={"left"}>
            eRecording: {dollarFormatter.format(fees?.eRecordingFee ?? 0)}
          </Typography>
          <Typography fontSize="20px" textAlign={"left"}>
            Legal and Vesting:{" "}
            {dollarFormatter.format(
              fees?.legalVestingFee ?? LEGAL_VESTING_FEES,
            )}
          </Typography>
          {offerAmount &&
            offerAmount > 250000 &&
            loan?.occupancy !== "Primary Residence" && (
              <Typography fontSize="20px" textAlign={"left"}>
                Lender Title Insurance Fee:{" "}
                {dollarFormatter.format(
                  loan?.borrowerSteps?.titleVerification
                    ?.lenderTitlePolicyFees ?? 0,
                )}
              </Typography>
            )}
          <Typography fontSize="20px" textAlign={"left"}>
            Taxes: {dollarFormatter.format(fees?.taxes ?? 0)}
          </Typography>
          {isWA && fees?.commDeptFee && (
            <Typography fontSize="20px" textAlign={"left"}>
              WA State Commerce Dept.:{" "}
              {dollarFormatter.format(fees?.commDeptFee)}
            </Typography>
          )}
        </Box>
        <Typography fontSize="22px" fontWeight={600} textAlign="left">
          <div style={{ display: "flex", alignItems: "center" }}>
            Total:{" "}
            {originationFee === undefined ||
            originationFee === null ||
            originationFee <= 0 ? (
              <Skeleton
                variant="text"
                width="10%"
                height="1.5rem"
                sx={{ display: "inline-block" }}
              />
            ) : (
              <span>{totalFormated}</span>
            )}
          </div>
        </Typography>
      </Box>
      <CButton
        type="reset"
        variant="contained"
        fullWidth
        onClick={onClose}
        sx={{
          marginTop: 2,
          backgroundColor: theme.palette.primary.main,
          color: "white",
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
          },
        }}
      >
        Close Details
      </CButton>
    </CDialog>
  );
};

export default FeesModal;
